<script setup>
import { onBeforeUnmount, onMounted, watch } from "vue";

import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
mapboxgl.accessToken = "pk.eyJ1IjoiYWFyY2lsYTE4IiwiYSI6ImNsM2V6YWdscjBuZDMzY3A3M2FtMDl6YWgifQ.adh5HQ_qhIy3cjG1a-pSAQ";

const props = defineProps(["locations","locations_icon","locations_area", "center", "area", "id", "harvest"]);
let map = null;
let markers = [];

const syncMarkers = () => {
    if (!map) {
        return;
    }

    markers.forEach(marker => marker.remove());
    markers = props.locations.map(element => {
        const markerElement = document.createElement('div');
        markerElement.className = 'mapMarker';
        markerElement.style.backgroundImage = `url(/images/${props.locations_icon})`;
        markerElement.style.width = '24px';
        markerElement.style.height = '24px';
        markerElement.style.backgroundSize = '100%';

        return new mapboxgl.Marker(markerElement).setLngLat(element).addTo(map);
    });
};

watch(() => props.locations, syncMarkers, { deep: true });

onMounted(() => {

    map = new mapboxgl.Map({
        container: props.id, // container ID
        style: "mapbox://styles/mapbox/satellite-streets-v11", // style URL
        center: props.center,
        zoom: 12, // starting zoom
        cooperativeGestures: false,
        projection: "globe", // display the map as a 3D globe
    });

    // Add geolocate control to the map.
    map.addControl(
    new mapboxgl.GeolocateControl({
    positionOptions: {
    enableHighAccuracy: true
    },
    // When active the map will receive updates to the device's location as it changes.
    trackUserLocation: true,
    // Draw an arrow next to the location dot to indicate which direction the device is heading.
    showUserHeading: true
    })
    );
    
    syncMarkers();

    if (props.area == true) {
        map.on("load", () => {
            // Add a data source containing GeoJSON data.
            props.locations_area.filter(element => element.length >= 4).forEach((element, index) => {
                map.addSource("maine"+index, {
                    type: "geojson",
                    data: {
                        type: "Feature",
                        geometry: {
                            type: "Polygon",
                            // These coordinates outline Maine.
                            coordinates: [
                                element,
                            ],
                        },
                    },
                });

                let fillColor = "#ebc634";
                if(index != 0 && props.harvest == true){
                    fillColor = "#007000";
                }

                // Add a new layer to visualize the polygon.
                map.addLayer({
                    id: "maine"+index,
                    type: "fill",
                    source: "maine"+index, // reference the data source
                    layout: {},
                    paint: {
                        "fill-color": fillColor, // blue color fill
                        "fill-opacity": 0.5,
                    },
                });

            });
            


        });
    }
    map.addControl(new mapboxgl.NavigationControl());
});

onBeforeUnmount(() => {
    markers.forEach(marker => marker.remove());
    markers = [];
    if (map) {
        map.remove();
        map = null;
    }
});
</script>

<template lang="">
    <div>
        <div :id="props.id" class="w-full h-96"></div>
    </div>
</template>

<style lang=""></style>
